{
    "IncludeendedonholdLabel": "Help weergeven bij alle instellingen van de centrale beheeromgeving.",
    "UnreturnedCalls_SectionHeader": "Niet beantwoorde oproepen",
    "UnreturnedCalls_SectionPara": "U kunt kiezen of gesprekken die in de wachtstand zijn beëindigd, als afgebroken worden beschouwd in de rapporten \"Niet-geretourneerde verloren oproepen\" en in de statistiek \"Niet-geretourneerde oproepen\".",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Inclusief Ontsnapt:"
}